import { departmentActions } from "../slices/departmentSlice";

import { toast } from "react-toastify";
import axios from "axios";

//Fetch all departments
export function fetchAllDepartments() {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `https://tabeeb-assyut-api.onrender.com/api/departments`
      );
      dispatch(departmentActions.setDepartments(data));
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
//Create department
export function createDepartment(department) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.post(
        `https://tabeeb-assyut-api.onrender.com/api/departments`,
        department,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(departmentActions.addDepartment(data));
      toast.success("تم اضافة تخصص بنجاح.");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}

//Update profile
export function updateDepartment(departmentId, newDepartment) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.put(
        `https://tabeeb-assyut-api.onrender.com/api/departments/${departmentId}`,
        newDepartment,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(departmentActions.setDepartment(data));
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };
}
//Delete department
export function deleteDepartment(departmentId) {
  return async (dispatch, getState) => {
    try {
      const { data } = await axios.delete(
        `https://tabeeb-assyut-api.onrender.com/api/departments/${departmentId}`,
        {
          headers: {
            Authorization: "Bearer " + getState().auth.user.token,
          },
        }
      );
      dispatch(departmentActions.deleteDepartment(data.departmentId));
      toast.success(data?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
}
